export enum CapiServerEventName {
  PAGEVIEW = "PageView",
  TEST_EVENT = "TestEvent",
  INITIATE_CHECKOUT = "InitiateCheckout",
  ADD_TO_CART = "AddToCart",
  PURCHASE = "Purchase",
}
